import { useBannersStore } from '~/stores/apostatudo/banners';
import { fetchBannersHandler } from '~/handlers/fetch-banners.handler';
import { fetchGuestBannerHandler } from '~/handlers/fetch-guest-banner.handler';

export const useBanners = () => {
  const bannersStore = useBannersStore();
  const { isAuthenticated } = storeToRefs(useAuthStore());

  const fetchBanners = async () => {
    bannersStore.loading = true;

    try {
      const result = await fetchBannersHandler();

      bannersStore.setBanners(result);

      if (!isAuthenticated.value && !bannersStore.guestBanner) {
        bannersStore.setGuestBanner(await fetchGuestBannerHandler());
      }
    } catch (error) {
      console.error('Error in useBanners:', error);
    } finally {
      bannersStore.loading = false;
    }
  };

  // Injeta o banner de cadastro como primeiro slide, só pra deslogado.
  // Reativo a isAuthenticated: some sozinho assim que o usuário loga,
  // sem precisar refazer o fetch.
  const homeBanners = computed(() => {
    if (isAuthenticated.value || !bannersStore.guestBanner) {
      return bannersStore.homeBanners;
    }

    return [bannersStore.guestBanner, ...bannersStore.homeBanners];
  });

  return {
    fetchBanners,
    mainBanners: computed(() => bannersStore.mainBanners),
    homeBanners,
    loading: computed(() => bannersStore.loading),
    hasMainBanners: computed(() => bannersStore.hasMainBanners),
    hasHomeBanners: computed(() => homeBanners.value.length > 0),
  };
};
